
import React from "react";
import moment from "moment-timezone";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row"; 

const Footer = (props) => {
  const currentYear = moment().get("year");
  
  return (
    <footer className="footer">
      <Row className="m-0">
        <Col xs={12} className="mt-2 mb-2 mb-lg-0" style={{width: "50%"}}>
          <p className="mb-0 text-dark-lc text-xl-left">
            Copyright © 2021-{`${currentYear} `}
          </p>
        </Col>
        <Col xs={12} style={{width: "50%"}}>
          <ul className="mt-2 mb-2 list-inline list-group-flush list-group-borderless text-right text-xl-right mb-0">
            <li className="list-inline-item px-0 px-sm-2">
              <Card.Link href="https://lightcast.io" target="_blank" >
                About
              </Card.Link>
            </li>
            <li className="list-inline-item px-0 px-sm-2">
              <Card.Link href="https://lightcast.io/contact" target="_blank"> 
                Contact
              </Card.Link>
            </li>
          </ul>
        </Col>
      </Row>
    </footer>
  );
};

export default Footer;